import * as Yup from 'yup';
import { isValid, parse } from '../utils/date';

export interface PersonForm {
  email: string;
  name: string;
  dateOfBirth?: string;
  identityNumber?: string;
  phoneNumber?: string;
  password?: string;
  socialName?: string;
}

export type PersonFormShape = {
  [key in keyof PersonForm]?: any;
};

export const schema = Yup.object().shape<PersonFormShape>({
  email: Yup.string().required('Digite o email').email('Digite o email válido'),
  dateOfBirth: Yup.mixed().test('dateOfBirth', 'Digite uma data válida', (value: string | null) =>
    value ? isValid(parse(value, 'dd/MM/yyyy', new Date())) : true
  ),
  identityNumber: Yup.string(),
  name: Yup.string().required('Digite um nome'),
  phoneNumber: Yup.mixed().test('phone', 'Digite um telefone válido', (value: string | null) =>
    value ? value.length > 10 : true
  ),
  password: Yup.string().min(8, 'Digite uma senha com no mínimo 8 caracteres'),
  socialName: Yup.string(),
});
